const importList = () => import('@/pages/device/import/index.vue');

export default [{
    path: '/device/import',
    component: importList,
    meta: [{
        name: '设备管理'
    },
    {
        name: '导入设备数据列表',
        activeRoute: '/device/import'
    }]
}];